
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 .004C9.192-.21.25 8.362.002 19.169a18.803 18.803 0 006.666 14.265v5.733a.833.833 0 001.275.706l4.645-2.901A20.633 20.633 0 0020 38.333c10.808.214 19.751-8.357 19.998-19.164C39.751 8.362 30.808-.21 20 .004z","fill":"#C4C4C4"}}),_c('path',{attrs:{"d":"M33.165 13.669a.833.833 0 00-1.066-.233l-8.666 4.724-5.391-4.623a.833.833 0 00-1.132.044L6.911 23.58A.833.833 0 007.9 24.9l8.666-4.725 5.396 4.624a.833.833 0 001.132-.043l9.999-9.999a.833.833 0 00.073-1.088z","fill":"#FAFAFA"}}),_c('path',{attrs:{"d":"M20 .004C9.192-.21.25 8.362.002 19.169a18.803 18.803 0 006.666 14.265v5.733a.833.833 0 001.275.706l4.645-2.901A20.633 20.633 0 0020 38.333c10.808.214 19.751-8.357 19.998-19.164C39.751 8.362 30.808-.21 20 .004z","fill":"#2196F3"}}),_c('path',{attrs:{"d":"M33.165 13.669a.833.833 0 00-1.066-.233l-8.666 4.724-5.391-4.623a.833.833 0 00-1.132.044L6.911 23.58A.833.833 0 007.9 24.9l8.666-4.725 5.396 4.624a.833.833 0 001.132-.043l9.999-9.999a.833.833 0 00.073-1.088z","fill":"#FAFAFA"}})])
          )
        }
      }
    